import React from 'react'
import { observer } from 'mobx-react-lite'
import { Form, Formik } from 'formik'
import { useParams } from 'react-router-dom'
import { CampaignSectionSchema } from '../../../../../schemas/CampaignSectionSchema'
import axiosService from '../../../../../utils/AxiosService'
import Input from '../../../../FormComponents/Input'
import { toastError, toastSuccess } from '../../../../FormComponents/Toasts'
import Modal from '../../../../Modal/Modal'
import { statusDisplayName } from '../../../../../utils/statusDisplayName'

export default observer(function EditSectionModal({ status, isOpen, setIsOpen }) {
  const { id } = useParams()
  const currentName = statusDisplayName(status)

  const renameSection = ({ name }, { setSubmitting }) => {
    return axiosService.patch(
      `/api/project_manager/campaigns/${id}/campaign_authentication_statuses/${status.id}`,
      { campaign_authentication_status: { name } }
    ).then((updatedStatus) => {
      status.name = updatedStatus.name
      setIsOpen(false)
      toastSuccess('List renamed')
    }).catch(({ data: { error } }) => {
      toastError(error)
      setSubmitting(false)
    })
  }

  return (
    <Modal isOpen={isOpen} onClose={() => setIsOpen(false)}>
      <Modal.Header>
        <span className="font-bold text-lg dark:text-white">Rename list</span>
      </Modal.Header>
      <Formik
        validationSchema={CampaignSectionSchema}
        initialValues={{ name: currentName }}
        enableReinitialize
        onSubmit={renameSection}
      >
        {({ handleBlur, handleChange, values, errors, touched, isSubmitting }) => {
          const unchanged = values.name.trim() === currentName
          return (
            <Form>
              <Modal.Body>
                <div className="w-[440px] flex flex-col gap-1">
                  <label className="text-sm font-semibold text-rb-black dark:text-white">List name</label>
                  <Input
                    autoFocus
                    topMargin="mt-0"
                    inputPaddingClass="px-3"
                    error={touched.name && errors.name}
                    placeholder="e.g. Shortlist"
                    name="name"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.name}
                  />
                  <p className="text-xs text-rb-lighter-grey dark:text-gray-400 mt-1">Shown as the column title in this campaign. Clients see it when the list is visible to them.</p>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <div className="w-full flex justify-between items-center">
                  <Modal.DissmissButton className="rb-btn-cancel px-4 py-2 text-sm font-semibold rounded-lg">
                    Cancel
                  </Modal.DissmissButton>
                  <button
                    type="submit"
                    disabled={isSubmitting || unchanged}
                    className="px-4 py-2 text-sm font-semibold text-white bg-rb-green rounded-lg dark:text-rb-dark-mode disabled:opacity-50"
                  >
                    {isSubmitting ? 'Saving...' : 'Save'}
                  </button>
                </div>
              </Modal.Footer>
            </Form>
          )
        }}
      </Formik>
    </Modal>
  )
})
